// Mental model: If you need a spacing of 40px, divide it by 4. That'll give you 10. Then use it in your component.

export const spacing = {
  'safe-top': 'env(safe-area-inset-top)',
  'safe-bottom': 'env(safe-area-inset-bottom)',
  'safe-left': 'env(safe-area-inset-left)',
  'safe-right': 'env(safe-area-inset-right)',
  18: '4.5rem',
};
